export default {
  home: {
    title: "Быстрый запуск",
    fastRun: "Быстрый запуск"
  }
};
